import axios_fetch, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AppStore } from '../store/AppStore';

type Cache = 'no-store' | 'default';
type Methods = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'HEAD';

export interface AxiosBodyRequestConfig extends AxiosRequestConfig {
    body?: any;
    cache?: Cache;
    method?: Methods;
    silent?: boolean;
    headers?: Record<string, string>;
    skipAuthentication?: boolean;
    data?: any;
    "axios-retry"?: {
        retries: number;
        shouldResetTimeout: boolean;
        retryDelay: (retryCount) => any;
        retryCondition: any;
    }
}

async function fetch<T>(url: string, options: AxiosBodyRequestConfig = { method: 'GET' }): Promise<AxiosResponse<T>> {
    if (options && options.body) {
        options.data = options.body;
    }

    AppStore.incrementarRequisicoes();
    return axios_fetch(url, options).finally(() => {
        AppStore.decrementarRequisicoes();
    });
}

export default fetch
